import React from "react";
import Logo from "../../components/Logo";
import { useTranslation } from "react-i18next";
import { logDTCrash, safeSendBizEvent } from "../../shared/analytics/dynatrace";
import { useReducers } from "../../shared/hooks/useReducer";
import constants from "../../shared/constants";
import "./style.scss";
import { DT_EVENTS, DT_ATTRIBUTES } from "../../shared/constants/dynatrace";

const { REDUCER_TYPE } = constants;

/**
 * Component that renders fallback error page when app crashes
 * @component
 */
function ErrorFallback({ error }) {
  const { t: translate } = useTranslation();
  const { featureToggles } = useReducers(REDUCER_TYPE.APP);
  const { isDynatraceTrackingEnabled } = featureToggles;

  // send business event to Dynatrace along with essential global attributes
  safeSendBizEvent(DT_EVENTS.APP_CRASH, {
    [DT_ATTRIBUTES.ERROR_MESSAGE]: error.message,
  });

  // Report error directly to Dynatrace
  logDTCrash(error, isDynatraceTrackingEnabled);

  return (
    <div className="fallback-error">
      <div className="app-logo">
        <Logo isClickable={false} />
      </div>
      <span className="error-text">
        <img className="warning" src={process.env.PUBLIC_URL + "/images/warning-icon.svg"} alt="warning" />
        {translate("sorry_error_occurred")}
      </span>
    </div>
  );
}

export default ErrorFallback;
